<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="white" />
    <path
      d="M36.7442 37.4555C36.0754 35.5621 34.6018 33.8889 32.5518 32.6956C30.5018 31.5023 27.99 30.8555 25.4061 30.8555C22.8221 30.8555 20.3104 31.5023 18.2604 32.6956C16.2104 33.8889 14.7367 35.5621 14.0679 37.4555"
      stroke="#125EAF"
      stroke-width="3"
      stroke-linecap="round"
    />
    <circle
      cx="25.4035"
      cy="19.1183"
      r="6.07143"
      stroke="#125EAF"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>
